import { RotateCcw } from 'lucide-react';
import { PIKKO_APP_DEEPLINK } from '../../../utils/appStoreRedirect';

const handleReactivate = async (onReactivate, setIsOpen) => {
  try {
    await onReactivate?.();
  } finally {
    window.open(PIKKO_APP_DEEPLINK, '_blank', 'noopener');
    setIsOpen(false);
  }
};

export const PikkoJackpotReactivateButton = ({ onReactivate, reactivateLoading, setIsOpen }) => (
  <button
    type="button"
    className="purchase-button footer-cart-button w-full"
    style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'center', fontSize: '17px',
      background: 'linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 50%, #BBF7D0 100%)',
      color: '#166534',
      boxShadow: '0 8px 0 #86EFAC',
    }}
    onClick={() => handleReactivate(onReactivate, setIsOpen)}
    disabled={reactivateLoading}
  >
    <RotateCcw size={20} strokeWidth={3} className={reactivateLoading ? 'animate-spin' : ''} style={{ color: '#166534', stroke: '#166534' }} />
    {reactivateLoading ? 'Réactivation...' : 'Réactiver'}
  </button>
);
